import React from "react";
import { ShieldCheck, Target, HeartHandshake } from "lucide-react";

export default function About() {
  return (
    <div className="fade-in max-w-5xl mx-auto px-4 md:px-6 py-16 md:py-24">
      <div className="text-xs uppercase tracking-[0.22em] text-[#138808] font-bold mb-3">About Us</div>
      <h1 className="serif text-4xl md:text-6xl font-semibold text-[#000080] leading-tight">
        Thirty years of hope, one child at a time.
      </h1>
      <p className="mt-6 text-lg text-[#4A4A4A] leading-relaxed max-w-3xl">
        Adopt Helpless Children Charitable Trust is a registered non-profit committed to uplifting underprivileged communities across India. Our work cuts across education, healthcare, women empowerment, environmental protection, and social justice — rooted in dignity, driven by data, and delivered with love.
      </p>

      <div className="mt-12 aspect-[16/7] rounded-3xl overflow-hidden shadow-xl">
        <img src="https://images.pexels.com/photos/30124240/pexels-photo-30124240.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=1200" alt="Children in community" className="w-full h-full object-cover" />
      </div>

      <div className="grid md:grid-cols-3 gap-6 mt-14">
        {[
          { icon: Target, title: "Our Mission", body: "To be the first responder for every child denied education, healthcare, or safety — and to leave no community behind." },
          { icon: HeartHandshake, title: "Our Approach", body: "Grassroots partnerships, women-led teams, data-backed decisions, and radical transparency." },
          { icon: ShieldCheck, title: "Our Trust Seals", body: "Reg. 250501328202 · 80G · 12A · CSR Reg · NGO DARPAN verified · E-anudan registered." },
        ].map((c, i) => (
          <div key={i} className="bg-white rounded-2xl border border-[#eae5d9] p-6" data-testid={`about-${i}`}>
            <c.icon className="w-6 h-6 text-[#FF9933] mb-3" strokeWidth={1.6} />
            <div className="serif text-xl font-semibold text-[#000080] mb-2">{c.title}</div>
            <div className="text-sm text-[#4A4A4A] leading-relaxed">{c.body}</div>
          </div>
        ))}
      </div>

      <div className="mt-16 p-8 bg-[#F3EFE7] rounded-3xl border border-[#eae5d9]">
        <h2 className="serif text-2xl text-[#000080] font-semibold mb-3">Registrations & Compliance</h2>
        <div className="grid md:grid-cols-2 gap-3 text-sm text-[#4A4A4A]">
          <div><b>Reg. No:</b> 250501328202</div>
          <div><b>NGO DARPAN ID:</b> BR/2025/0867253</div>
          <div><b>PAN:</b> AAMTA0405B</div>
          <div><b>80G Reg:</b> AAMTA0405BF2025101</div>
          <div><b>12A Reg:</b> AAMTA0405BE2025101</div>
          <div><b>CSR Reg:</b> CSR00103199</div>
          <div><b>E-anudan:</b> BR/00049949</div>
          <div><b>SBI A/C:</b> 44703110576 · IFSC: SBIN0018600</div>
        </div>
      </div>
    </div>
  );
}
